/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import RaiseQueryPopup from "../RaiseQuerypopup/RaiseQueryPopup.vue";
import moment from "moment";
export default {
    name: 'viewAlertDetailsPopup',
    components: {
        customModal,
        RaiseQueryPopup
    },
    props: {
        AlertId: {
            type: String,
            default: ''
        },
        AlertType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            comments: "",
            alertDetails: [],
            alertItem: [],
            defaultdate:"",
            showRaiseQuery: false,
            querycountvar: "",
            roleprivileges:"",
        }
    },
    async mounted() {
        this.roleprivileges = store.getters.getRolesprivilegeData;
         this.defaultdate=localStorage.getItem("dateformat");
        await this.callMethod();
        await this.querycount();
    },
    methods: {
        async querycount() {
            this.querycountvar = "0";
            try {
            const token = store.getters.getIdToken;
            const response = await axios.get(
                `${this.baseapi}/forms/query/querylist?StudyId=${store.getters.getStudyIs}&QueryFor_Id=${this.AlertId}&QueryStatus=Open`,
                { headers: { Authorization: "Bearer " + token } }
            );
            this.querycountvar = response.data.totalCount ? response.data.totalCount : "0";
            this.$emit("queryAlertCount")
            } catch (error) {
            console.error("Error fetching query details:", error);
            }
        },
        Openquerypopup(emittedvar) {
            this.querypopup = true;
            this.$emit("openQueryPopup",emittedvar)
        },
        Closequerypopup(){
            this.querypopup = false;
        },
        filterDate(data) {
                if(data){
                return moment(data).format(this.defaultdate)
                }
            },
        relativeTime(data) {
                if (data) {
                    return moment(data).format('h:mm:ss');
                }
            },
        openResolveModal(){
            this.$emit("callViewModal",this.AlertId)
        },  
        async callMethod() {
            if (this.AlertType == 'active alerts') {
                this.getActiveAlerts();
            }
            else if (this.AlertType == 'recent alerts') {
                this.getRecentAlerts();
            }
        },
        async getActiveAlerts() {
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseapi}/forms/alert/getaudits?Id=${this.AlertId}&Active=true`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.alertDetails = response.data.entities[0];
                this.alertItem = this.alertDetails.alertConfig;
            } catch (error) {
                console.error("Error fetching alerts:", error);
            }
        },
        async getRecentAlerts() {
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseapi}/forms/alert/getaudits?Id=${this.AlertId}`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.alertDetails = response.data.entities[0];
                this.alertItem = this.alertDetails.alertConfig;
                console.log("active alert is,", this.alertDetails)
            } catch (error) {
                console.error("Error fetching alerts:", error);
            }
        },
        closeAssignModal() {
            this.$emit("closeModal");
        },
        async closeQueryModal(){
            this.showRaiseQuery = false;
        },
        gotoraiseQuary(queryType, FieldName) {
            this.showRaiseQuery = true;
    
            // var temp =  this.alertItem.FormId + "modelNameIs_" + FieldName;
            // this.$router.push(`/raiseQuery/${temp}/${queryType}/1`);
        },

    }

};